export default __webpack_public_path__ + "static/media/Dashboard_Line.a2532735.svg";